"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { LoadingSpinner } from "./components/LoadingSpinner";
import { useCobrandAuth } from "./hooks/useCobrandAuth";

export default function CobrandManagementPage() {
    const router = useRouter();
    const { isLoading, isAuthenticated } = useCobrandAuth();

    useEffect(() => {
        if (!isLoading) {
            router.push(isAuthenticated ? "/cobrand-management/app" : "/cobrand-management/login");
        }
    }, [isLoading, isAuthenticated, router]);

    // Show loading spinner while checking session and redirecting
    return <LoadingSpinner />;
}
